import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, Ruler, Radio, Hash } from 'lucide-react';
const stats = [{
  icon: Mountain,
  value: '1 214 ft',
  label: 'Nadmořská výška (370m)'
}, {
  icon: Ruler,
  value: '1 170m',
  label: 'Dráha 06/24 (Asfalt)'
}, {
  icon: Radio,
  value: '135.580',
  label: 'Hořovice Radio'
}, {
  icon: Hash,
  value: 'LKHV',
  label: 'ICAO kód'
}];
export function Stats() {
  return <section className="w-full bg-[#0f1d35] border-y border-white/5" data-id="element-486">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-487">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-488">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center group" data-id="element-489">
              <div className="mb-4 p-3 bg-[#0a1628] rounded-full border border-white/5 group-hover:border-[#38bdf8]/30 transition-colors" data-id="element-490">
                <stat.icon className="w-6 h-6 text-[#38bdf8]" data-id="element-491" />
              </div>
              <span className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-492">
                {stat.value}
              </span>
              <span className="text-sm text-white/50 uppercase tracking-wider font-medium" data-id="element-493">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}